// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

// Public pages
import HomePage from "./pages/HomePage";
import NewsPage from "./components/News";
import FullNews from "./components/FullNews";
import Sponsors from "./pages/Sponsorer";
import Gallery from "./pages/Galleri";
import Rules from "./pages/Rules";
import Products from "./pages/Products";
import OpeningHoursPage from "./pages/OpeningHoursPage";
import Court from "./pages/Courses";
import Content from "./pages/Association";
import Avgift from "./components/Avgifter";
import Competitions from "./components/Competitions";
import CookiesPage from "./pages/CookiesPage";
import ContactForm from "./components/ContactForm";

// Admin
import RequireAdmin from "./admin/RequireAdmin";
import AdminLoginPage from "./admin/AdminLoginPage";
import AdminPanel from "./admin/AdminPanel";

// ✅ LÄGG TILL DESSA SEN NÄR DU SKAPAT FILERNA
import AdminOpeningHours from "./adminpanel/AdminOpeningHours";
import AdminAvgifter from "./adminpanel/AdminAvgifter";
import AdminProducts from "./adminpanel/AdminProducts";
import AdminNews from "./adminpanel/AdminNews";
import AdminGallery from "./adminpanel/AdminGallery";
import AdminCompetitions from "./adminpanel/AdminCompetitions";
import AdminBanor from "./adminpanel/AdminBanor";
import AdminSponsors from "./adminpanel/AdminSponsors";
import AdminRules from "./adminpanel/AdminRule";
import AdminForening from "./adminpanel/AdminForening";
import AdminIntyg from "./adminpanel/AdminIntyg";
import AdminContactMessages from "./adminpanel/AdminContactMessages";

import logo from "./assets/logo.png";

export default function App() {
  return (
    <>
      <Header logoSrc={logo} isAdmin={false} />

      <Routes>
        {/* Public */}
        <Route path="/" element={<HomePage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<FullNews />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route path="/galleri" element={<Gallery />} />
        <Route path="/regler" element={<Rules />} />
        <Route path="/banor" element={<Court />} />
        <Route path="/butik" element={<Products />} />
        <Route path="/avgifter" element={<Avgift />} />
        <Route path="/foreningen" element={<Content />} />
        <Route path="/tavlingar" element={<Competitions />} />
        <Route path="/opening-hours" element={<OpeningHoursPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/kontakt" element={<ContactForm />} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLoginPage />} />

        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminPanel />
            </RequireAdmin>
          }
        />

    
        <Route path="/admin/opening-hours" element={<RequireAdmin><AdminOpeningHours /></RequireAdmin>} />
        <Route path="/admin/avgifter" element={<RequireAdmin><AdminAvgifter /></RequireAdmin>} />
        <Route path="/admin/products" element={<RequireAdmin><AdminProducts /></RequireAdmin>} />
        <Route path="/admin/news" element={<RequireAdmin><AdminNews /></RequireAdmin>} />
        <Route path="/admin/gallery" element={<RequireAdmin><AdminGallery /></RequireAdmin>} />
        <Route path="/admin/competitions" element={<RequireAdmin><AdminCompetitions /></RequireAdmin>} />
        <Route path="/admin/banor" element={<RequireAdmin><AdminBanor /></RequireAdmin>} />
        <Route path="/admin/sponsors" element={<RequireAdmin><AdminSponsors /></RequireAdmin>} />
        <Route path="/admin/regler" element={<RequireAdmin><AdminRules /></RequireAdmin>} />
        <Route path="/admin/forening" element={<RequireAdmin><AdminForening /></RequireAdmin>} />
<Route path="/admin/intyg" element={<RequireAdmin><AdminIntyg /></RequireAdmin>} />
<Route
  path="/admin/kontakt"
  element={
    <RequireAdmin>
      <AdminContactMessages />
    </RequireAdmin>
  }
/>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
    </>
  );
}



